export default [
    {
        text: 'código',
        value: 'auth_code',
    },
    {
        text: 'rut',
        value: 'rutUser',
        format: 'rut',
    },
    {
        text: 'nombre completo',
        value: 'userFullName',
    },
    {
        text: 'comisiones',
        value: 'commissionsUser',
    },
    {
        text: 'terreno',
        value: 'userIsGroundSeller',
        format: 'boolean',
    },
    {
        text: 'n° clientes',
        value: 'customersUser',
    },
]
